if (typeof document !== 'undefined' && typeof global._babelPolyfill === 'undefined') {
  require('@babel/polyfill')
  require('react-app-polyfill/ie11')
  require('react-app-polyfill/stable')
  require('raf').polyfill()
  require('./nodelist_foreach')
}
